import { Component, OnInit } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { PrintService } from 'src/app/core/services/print.service';
import { Client } from 'src/app/shared/models/clients/client';
import { Opponent } from 'src/app/shared/models/data/opponent';
import { CaseSession } from 'src/app/shared/models/hearings/caseSession';
import { User, UserRole } from 'src/app/shared/models/users/user';

@Component({
  selector: 'app-print-case-session',
  templateUrl: './print-case-session.component.html',
  styleUrls: ['./print-case-session.component.scss']
})
export class PrintCaseSessionComponent implements OnInit {
  session: CaseSession;
  clients: Client[];
  opponents: Opponent[];
  fileNum: string;
  ColumnMode = ColumnMode;
  lawyersStr: string[];
  lawyersArStr: string[];
  user: User;
  userRole = UserRole;


  constructor(
    private printService: PrintService,
    private auth: AuthService,
  ) {
    this.user = this.auth.user;
    this.getServiceData();
  }

  ngOnInit(): void {
    this.printService.onDataReady('Court Hearing');
  }

  getServiceData() {
    this.session = this.printService.data.session;
    this.lawyersStr = this.printService.data.lawyersStr;
    this.lawyersArStr = this.printService.data.lawyersArStr;
  }

}
